var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _rect, _rect2, _path17, _circle, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _text, _path29, _path30, _path31, _path32, _path33, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoverLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 4150.47 980.43",
    style: {
      enableBackground: "new 0 0 4150.47 980.43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6A1A;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#2E344A;}\r\n\t.st3{font-family:'Lato-Bold';}\r\n\t.st4{font-size:875.3659px;}\r\n\t.st5{letter-spacing:49;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M736.48,388.35l-222.64,73.51l-70.19-212.58c-4.91-14.87,3.24-31.05,18.1-35.96l195.61-64.59L736.48,388.35z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M982.14,307.24l-235.73,77.83l-79.12-239.62l208.7-68.9c14.86-4.91,31.04,3.24,35.95,18.1L982.14,307.24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M806.45,600.28l-195.6,64.58c-14.87,4.91-31.05-3.24-35.96-18.11l-57.77-174.96l222.63-73.51L806.45,600.28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1025.08,528.08L816.38,597l-66.7-202l235.73-77.84l57.77,174.97C1048.09,506.99,1039.95,523.17,1025.08,528.08 z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M683.33-3436.96l-224.38,74.08l-70.3-212.9c-4.91-14.87,3.24-31.05,18.1-35.96l197.35-65.16L683.33-3436.96z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M927.24-3517.5l-236.26,78.01l-79.22-239.94l209.23-69.08c14.86-4.91,31.04,3.24,35.95,18.1L927.24-3517.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M753.19-3225.36l-197.34,65.16c-14.87,4.91-31.05-3.24-35.96-18.11l-58.41-176.91l224.37-74.09L753.19-3225.36z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M970.08-3296.98l-209.23,69.09l-67.34-203.94l236.26-78.01l58.41,176.91 C993.09-3318.07,984.95-3301.89,970.08-3296.98z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M612.93-3674.91L493.17-4037.6c1.57,3.71,3,7.51,4.28,11.39L612.93-3674.91z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M483.06-4342.48l-185.03-15.05c-1.89-0.15-3.76-0.37-5.6-0.65l185.45,15.2 C479.61-4342.84,481.34-4342.67,483.06-4342.48z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1040.22-3200.54c-5.63-17.35-24.42-26.95-41.77-21.32l-429.47,140.45c-23.86-36.65-65.19-60.89-112.18-60.89 c-3.16,0-6.29,0.11-9.4,0.33l-117.64-356.31l-0.04-0.1l-63.59-187.88c-7.93-23.45-21.94-43.7-40-59.14 c-16.32-13.96-35.94-23.99-57.36-28.91c-5.77-1.32-11.66-2.28-17.65-2.84l-80.61-8.97c-17.05,0-31.65,13.2-33.05,30.47 c-1.42,17.43,11.08,32.93,28.14,35.48l73.8,6.05c0.68,0.06,1.37,0.13,2.06,0.2c27.87,3.03,51.79,20.96,62.63,46.57 c0.83,1.96,1.58,3.96,2.25,6l60.81,184.97l0.26,0.8l117.06,354.5c-36.96,23.81-61.44,65.32-61.44,112.54 c0,73.88,59.89,133.76,133.77,133.76c73.87,0,133.76-59.88,133.76-133.76c0-3.37-0.13-6.72-0.37-10.03l428.72-140.2 c13.98-4.54,22.92-17.63,22.92-31.62C1041.83-3193.75,1041.31-3197.18,1040.22-3200.54z M456.96-2976.64 c-17.58,0-31.83-14.25-31.83-31.83c0-17.58,14.25-31.83,31.83-31.83s31.84,14.25,31.84,31.83 C488.8-2990.89,474.54-2976.64,456.96-2976.64z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M508.92-5080.38H-236.6c-6.6,0-12-5.4-12-12v-624c0-6.6,5.4-12,12-12h745.51c6.6,0,12,5.4,12,12v624 C520.92-5085.78,515.52-5080.38,508.92-5080.38z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1380.41-5080.38H634.9c-6.6,0-12-5.4-12-12v-624c0-6.6,5.4-12,12-12h745.51c6.6,0,12,5.4,12,12v624 C1392.41-5085.78,1387.01-5080.38,1380.41-5080.38z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2251.91-5080.38H1506.4c-6.6,0-12-5.4-12-12v-624c0-6.6,5.4-12,12-12h745.51c6.6,0,12,5.4,12,12v624 C2263.91-5085.78,2258.51-5080.38,2251.91-5080.38z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3123.4-5080.38h-745.51c-6.6,0-12-5.4-12-12v-624c0-6.6,5.4-12,12-12h745.51c6.6,0,12,5.4,12,12v624 C3135.4-5085.78,3130-5080.38,3123.4-5080.38z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-2959.38-3296.98l-414.23,136.78c-14.87,4.91-31.05-3.24-35.95-18.1l-131.24-397.48 c-4.91-14.87,3.24-31.05,18.1-35.95l414.23-136.78c14.87-4.91,31.05,3.24,35.95,18.1l131.24,397.48 C-2936.37-3318.07-2944.52-3301.89-2959.38-3296.98z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -3245.08,
    y: -3753.68,
    transform: "matrix(0.9496 -0.3135 0.3135 0.9496 913.3975 -1189.3883)",
    className: "st1",
    width: 8.06,
    height: 638.57
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -3245.08,
    y: -3753.68,
    transform: "matrix(-0.3135 -0.9496 0.9496 -0.3135 -996.0359 -7588.8423)",
    className: "st1",
    width: 8.06,
    height: 638.57
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-2921.81-3178.13c0,13.99-8.95,27.08-22.93,31.61l-394.54,127.94c0.25,3.31,0.37,6.66,0.37,10.03 c0,73.87-59.89,133.76-133.76,133.76c-73.88,0-133.76-59.89-133.76-133.76c0-47.23,24.47-88.74,61.43-112.54l-117.06-354.51 l-0.26-0.79l-60.81-184.97c-0.67-2.04-1.42-4.04-2.25-6c-10.84-25.61-34.76-43.54-62.63-46.57c-0.68-0.08-1.37-0.14-2.06-0.2 l-73.8-6.05c-17.05-2.56-29.55-18.06-28.14-35.48c1.4-17.28,16-30.47,33.05-30.47l80.61,8.97c5.99,0.56,11.89,1.51,17.65,2.84 c21.42,4.91,41.04,14.95,57.36,28.91c18.06,15.44,32.07,35.69,40,59.13l63.59,187.88l0.04,0.1l117.65,356.31 c3.1-0.22,6.24-0.33,9.39-0.33c46.99,0,88.33,24.24,112.18,60.89l395.29-128.19c17.35-5.63,36.15,3.96,41.77,21.31 C-2922.33-3184.92-2921.81-3181.5-2921.81-3178.13z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -3472.5,
    cy: -3008.47,
    r: 31.83
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1420.9377 -3081.4275)",
    className: "st2",
    style: {
      fontFamily: "'Gerbil-Regular'",
      fontSize: "632.2827px",
      letterSpacing: 69
    }
  }, "Rover"), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M683.33-2161.74l-224.38,74.08l-70.3-212.9c-4.91-14.87,3.24-31.05,18.1-35.96l197.35-65.16L683.33-2161.74z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M927.24-2242.28l-236.26,78.01l-79.22-239.94l209.23-69.08c14.86-4.91,31.04,3.24,35.95,18.1L927.24-2242.28z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M753.19-1950.15l-197.34,65.16c-14.87,4.91-31.05-3.24-35.96-18.11L461.48-2080l224.37-74.09L753.19-1950.15z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M970.08-2021.76l-209.23,69.09l-67.34-203.94l236.26-78.01l58.41,176.91 C993.09-2042.85,984.95-2026.67,970.08-2021.76z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1040.22-1925.33c-5.63-17.35-24.42-26.95-41.77-21.32l-429.47,140.45c-23.86-36.65-65.19-60.89-112.18-60.89 c-3.16,0-6.29,0.11-9.4,0.33l-117.64-356.31l-0.04-0.1l-63.59-187.88c-7.93-23.45-21.94-43.7-40-59.14 c-16.32-13.96-35.94-23.99-57.36-28.91c-5.77-1.32-11.66-2.28-17.65-2.84l-80.61-8.97c-17.05,0-31.65,13.2-33.05,30.47 c-1.42,17.43,11.08,32.93,28.14,35.48l73.8,6.05c0.68,0.06,1.37,0.13,2.06,0.2c27.87,3.03,51.79,20.96,62.63,46.57 c0.83,1.96,1.58,3.96,2.25,6l60.81,184.97l0.26,0.8l117.06,354.5c-36.96,23.81-61.44,65.32-61.44,112.54 c0,73.88,59.89,133.76,133.77,133.76c73.87,0,133.76-59.88,133.76-133.76c0-3.37-0.13-6.72-0.37-10.03l428.72-140.2 c13.98-4.54,22.92-17.63,22.92-31.62C1041.83-1918.54,1041.31-1921.97,1040.22-1925.33z M456.96-1701.42 c-17.58,0-31.83-14.25-31.83-31.83c0-17.58,14.25-31.83,31.83-31.83s31.84,14.25,31.84,31.83 C488.8-1715.67,474.54-1701.42,456.96-1701.42z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1420.9377 -1806.2126)",
    className: "st2",
    style: {
      fontFamily: "'Gerbil-Regular'",
      fontSize: "632.2827px",
      letterSpacing: 69
    }
  }, "Rover"), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M683.33-951.1l-224.38,74.08l-70.3-212.9c-4.91-14.87,3.24-31.05,18.1-35.96l197.35-65.16L683.33-951.1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M927.24-1031.64l-236.26,78.01l-79.22-239.94l209.23-69.08c14.86-4.91,31.04,3.24,35.95,18.1L927.24-1031.64z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M753.19-739.5l-197.34,65.16c-14.87,4.91-31.05-3.24-35.96-18.11l-58.41-176.91l224.37-74.09L753.19-739.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M970.08-811.12l-209.23,69.09l-67.34-203.94l236.26-78.01l58.41,176.91 C993.09-832.21,984.95-816.03,970.08-811.12z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1040.22-714.68c-5.63-17.35-24.42-26.95-41.77-21.32L568.98-595.55c-23.86-36.65-65.19-60.89-112.18-60.89 c-3.16,0-6.29,0.11-9.4,0.33l-117.64-356.31l-0.04-0.1l-63.59-187.88c-7.93-23.45-21.94-43.7-40-59.14 c-16.32-13.96-35.94-23.99-57.36-28.91c-5.77-1.32-11.66-2.28-17.65-2.84l-80.61-8.97c-17.05,0-31.65,13.2-33.05,30.47 c-1.42,17.43,11.08,32.93,28.14,35.48l73.8,6.05c0.68,0.06,1.37,0.13,2.06,0.2c27.87,3.03,51.79,20.96,62.63,46.57 c0.83,1.96,1.58,3.96,2.25,6l60.81,184.97l0.26,0.8l117.06,354.5c-36.96,23.81-61.44,65.32-61.44,112.54 c0,73.88,59.89,133.76,133.77,133.76c73.87,0,133.76-59.88,133.76-133.76c0-3.37-0.13-6.72-0.37-10.03l428.72-140.2 c13.98-4.54,22.92-17.63,22.92-31.62C1041.83-707.89,1041.31-711.32,1040.22-714.68z M456.96-490.78 c-17.58,0-31.83-14.25-31.83-31.83c0-17.58,14.25-31.83,31.83-31.83s31.84,14.25,31.84,31.83 C488.8-505.03,474.54-490.78,456.96-490.78z"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1420.937 -601.784)",
    className: "st2 st3",
    style: {
      fontSize: "742.8638px",
      letterSpacing: 74
    }
  }, "Rover"), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1095.22,624.52c-5.63-17.35-24.42-26.95-41.77-21.32L623.98,743.65c-23.86-36.65-65.19-60.89-112.18-60.89 c-3.16,0-6.29,0.11-9.4,0.33L384.76,326.78l-0.04-0.1L321.13,138.8c-7.93-23.45-21.94-43.7-40-59.14 c-16.32-13.96-35.94-23.99-57.36-28.91c-5.77-1.32-11.66-2.28-17.65-2.84l-80.61-8.97c-17.05,0-31.65,13.2-33.05,30.47 c-1.42,17.43,11.08,32.93,28.14,35.48l73.8,6.05c0.68,0.06,1.37,0.13,2.06,0.2c27.87,3.03,51.79,20.96,62.63,46.57 c0.83,1.96,1.58,3.96,2.25,6l60.81,184.97l0.26,0.8l117.06,354.5c-36.96,23.81-61.44,65.32-61.44,112.54 c0,73.88,59.89,133.76,133.77,133.76c73.87,0,133.76-59.88,133.76-133.76c0-3.37-0.13-6.72-0.37-10.03l428.72-140.2 c13.98-4.54,22.92-17.63,22.92-31.62C1096.83,631.31,1096.31,627.88,1095.22,624.52z M511.96,848.42 c-17.58,0-31.83-14.25-31.83-31.83c0-17.58,14.25-31.83,31.83-31.83c17.58,0,31.84,14.25,31.84,31.83 C543.8,834.17,529.54,848.42,511.96,848.42z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 1420.9375 774.8478)",
    className: "st2 st3 st4 st5"
  }, "Rover")), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1363.3,388.1l-224.38,74.08l-70.3-212.9c-4.91-14.87,3.24-31.05,18.1-35.96l197.35-65.16L-1363.3,388.1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1119.39,307.56l-236.26,78.01l-79.22-239.94l209.23-69.08c14.86-4.91,31.04,3.24,35.95,18.1L-1119.39,307.56z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1293.44,599.7l-197.34,65.16c-14.87,4.91-31.05-3.24-35.96-18.11l-58.41-176.91l224.37-74.09L-1293.44,599.7z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-1076.55,528.08l-209.23,69.09l-67.34-203.94l236.26-78.01l58.41,176.91 C-1053.54,506.99-1061.68,523.17-1076.55,528.08z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-1006.42,624.52c-5.63-17.35-24.42-26.95-41.77-21.32l-429.47,140.45c-23.86-36.65-65.19-60.89-112.18-60.89 c-3.16,0-6.29,0.11-9.4,0.33l-117.64-356.31l-0.04-0.1l-63.59-187.88c-7.93-23.45-21.94-43.7-40-59.14 c-16.32-13.96-35.94-23.99-57.36-28.91c-5.77-1.32-11.66-2.28-17.65-2.84l-80.61-8.97c-17.05,0-31.65,13.2-33.05,30.47 c-1.42,17.43,11.08,32.93,28.14,35.48l73.8,6.05c0.68,0.06,1.37,0.13,2.06,0.2c27.87,3.03,51.79,20.96,62.63,46.57 c0.83,1.96,1.58,3.96,2.25,6l60.81,184.97l0.26,0.8l117.06,354.5c-36.96,23.81-61.44,65.32-61.44,112.54 c0,73.88,59.89,133.76,133.77,133.76c73.87,0,133.76-59.88,133.76-133.76c0-3.37-0.13-6.72-0.37-10.03l428.72-140.2 c13.98-4.54,22.92-17.63,22.92-31.62C-1004.81,631.31-1005.33,627.88-1006.42,624.52z M-1589.67,848.42 c-17.58,0-31.83-14.25-31.83-31.83c0-17.58,14.25-31.83,31.83-31.83c17.58,0,31.84,14.25,31.84,31.83 C-1557.83,834.17-1572.09,848.42-1589.67,848.42z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -1620.78,
    y: 384.35,
    transform: "matrix(0.9496 -0.3135 0.3135 0.9496 -190.3279 -404.3183)",
    className: "st1",
    width: 537.13,
    height: 10.46
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -1367.31,
    y: 112.43,
    transform: "matrix(0.9496 -0.3135 0.3135 0.9496 -188.1331 -407.8438)",
    className: "st1",
    width: 10.46,
    height: 537.13
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 436.32,
    y: -955.09,
    transform: "matrix(0.9496 -0.3135 0.3135 0.9496 332.907 169.9344)",
    className: "st1",
    width: 516.94,
    height: 10.06
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 680.27,
    y: -1216.8,
    transform: "matrix(0.9496 -0.3135 0.3135 0.9496 335.0193 166.5414)",
    className: "st1",
    width: 10.06,
    height: 516.94
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 424.44,
    y: -2165.54,
    transform: "matrix(0.9496 -0.3135 0.3135 0.9496 712.3408 108.869)",
    className: "st1",
    width: 540.42,
    height: 10.52
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 679.47,
    y: -2439.12,
    transform: "matrix(0.9496 -0.3135 0.3135 0.9496 714.549 105.3219)",
    className: "st1",
    width: 10.52,
    height: 540.42
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 424.88,
    y: -3440.66,
    transform: "matrix(0.9496 -0.3135 0.3135 0.9496 1112.1185 44.4684)",
    className: "st1",
    width: 538.86,
    height: 10.49
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 679.17,
    y: -3713.46,
    transform: "matrix(0.9496 -0.3135 0.3135 0.9496 1114.3204 40.9315)",
    className: "st1",
    width: 10.49,
    height: 538.86
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoverLogo);
export default __webpack_public_path__ + "static/media/Rover Logo.3a34d9be99fd4e618a87b98d37f6db7e.svg";
export { ForwardRef as ReactComponent };